import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";

import { geofenceSelectSuccess } from "./actions";
import { authApiAccessCheck } from "../auth/actions";

import { GeofenceGetBySubscriber } from "../../api-tasks/geofence-changes";
import { GEOFENCE_SELECT_REQUEST } from "../actions";

function* selectGeofence({payload}) {
    
    const state = yield select();
    const { history } = payload;
    try {
      const authUser = state.authUser;
      const user = authUser.user;
  
      const resultSet = yield call(GeofenceGetBySubscriber, user.userToken);
      
      if (resultSet) {
        if (Array.isArray(resultSet)) {
          yield put(geofenceSelectSuccess(resultSet));
        } else { 
            yield put(authApiAccessCheck(history, resultSet));
        }
      }
    } catch (error) {
      console.log("error vehicle saga 1 :", error);
    }
  }

  export function* watchSelectAllRequest() {
    yield takeEvery(GEOFENCE_SELECT_REQUEST, selectGeofence);
  }

  export default function* rootSaga() {
    yield all([fork(watchSelectAllRequest)]);
  }
